import { compose, withProps } from 'recompose'
import { isThirdPartyUrl } from 'components/CareersPage/helpers'
import SelectOrApplyButton from './SelectOrApplyButton'

const withCTAProps = withProps(({
  localStoreOpportunitiesMode
}) => ({
  isExternalLink: isThirdPartyUrl(localStoreOpportunitiesMode)
}))

export default compose(
  withCTAProps
)(SelectOrApplyButton)
